import { Component, HostBinding, input, Input, output } from '@angular/core';
import { TableOverlayRowRemoveContainerComponent } from './table-overlay-row-remove-container/table-overlay-row-remove-container.component';

import { TableData } from '../../../../../table-overlay/table-overlay';
import { Dimension2d } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-overlay-row',
  imports: [TableOverlayRowRemoveContainerComponent],
  templateUrl: './table-overlay-row.component.html',
  styles: [
    `
      :host {
        @apply pointer-events-none flex w-full justify-center;
      }
    `,
  ],
})
export class TableOverlayRowComponent {
  @Input({ required: true }) tableData!: TableData;
  @Input({ required: true }) isIgnored!: boolean;
  @Input({ required: true }) rowIndex!: number;

  readonly dimension = input.required<Dimension2d>();

  toggleIgnoreForRow = output();

  @HostBinding('class.bg-transparent') get transparent() {
    return this.isIgnored;
  }

  @HostBinding('class.bg-[#78D8ED26]') get opaque() {
    return !this.isIgnored;
  }

  @HostBinding('style.height.px') get height(): number {
    const horizontalLines = this.tableData.lines.horizontal();
    const topLine = horizontalLines[this.rowIndex];
    const bottomLine = horizontalLines[this.rowIndex + 1];
    return (bottomLine.offset() - topLine.offset()) * this.dimension().height;
  }
}
